import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-validate-user',
  templateUrl: './validate-user.component.html',
  styleUrls: ['./validate-user.component.scss']
})
export class ValidateUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
